import React from 'react';
import { plural, toInputDate } from '../utils/format';
import Icon from './Icon';

interface FiltersProps {
  dateFrom: string;
  setDateFrom: (d: string) => void;
  dateTo: string;
  setDateTo: (d: string) => void;
  filteredCount: number;
  totalCount: number;
  onStart: () => void;
}

const RANGES = [
  { label: 'All time', days: null },
  { label: 'Last 7 days', days: 7 },
  { label: 'Last 30 days', days: 30 },
  { label: 'Last 90 days', days: 90 },
];

export default function Filters({
  dateFrom, setDateFrom, dateTo, setDateTo,
  filteredCount, totalCount, onStart,
}: FiltersProps) {
  const today = toInputDate(Date.now());
  const activeRange = RANGES.find(r =>
    r.days === null
      ? !dateFrom && !dateTo
      : dateTo === today && dateFrom === toInputDate(Date.now() - (r.days - 1) * 86400000),
  );

  function applyRange(days: number | null) {
    if (days === null) {
      setDateFrom('');
      setDateTo('');
    } else {
      setDateFrom(toInputDate(Date.now() - (days - 1) * 86400000));
      setDateTo(today);
    }
  }

  return (
    <div className="page-narrow">
      <div className="page-header">
        <div>
          <h1 className="page-title">Custom practice</h1>
          <p className="page-subtitle">
            Pick problems by when you saved them. Results still update your review schedule.
          </p>
        </div>
      </div>

      <section className="card">
        <div className="card-body">
          <div className="field">
            <span className="field-label">Saved between</span>
            <div className="segmented" role="group" aria-label="Quick ranges">
              {RANGES.map(r => (
                <button
                  key={r.label}
                  className={activeRange === r ? 'active' : ''}
                  onClick={() => applyRange(r.days)}
                >
                  {r.label}
                </button>
              ))}
            </div>
            <div className="date-range">
              <input
                className="input"
                type="date"
                aria-label="From"
                value={dateFrom}
                max={dateTo || undefined}
                onChange={e => setDateFrom(e.target.value)}
              />
              <span className="date-sep">to</span>
              <input
                className="input"
                type="date"
                aria-label="To"
                value={dateTo}
                min={dateFrom || undefined}
                onChange={e => setDateTo(e.target.value)}
              />
            </div>
          </div>
        </div>
        <div className="card-footer">
          <span className="next-hint">
            <strong>{filteredCount}</strong> of {plural(totalCount, 'problem')} match · 5 min each
          </span>
          <span className="spacer" />
          <button className="btn btn-primary" onClick={onStart} disabled={filteredCount === 0}>
            <Icon name="play" size={14} />
            Start {plural(filteredCount, 'problem')}
          </button>
        </div>
      </section>
    </div>
  );
}
